import { render } from "./Headers.vue?vue&type=template&id=3f8692b8"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"

import "./Headers.vue?vue&type=style&index=0&id=3f8692b8&lang=css"

import exportComponent from "/Users/twchou/workspace/work/csunion/highschool_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__